import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import BonusRecord from "integration/revolver/schema/bonus-record";

export default class FreespinsTriggered extends Decision {
    public evaluate() {
        let record = GameState.getCurrentGame().getCurrentRecord();

        let triggered = false;
        
        if (record instanceof SpinRecord || record instanceof BonusRecord) {
            triggered = record.freespinsTriggered;
        }

        if (record.beenPaid) { // todo
            triggered = false;
        }
        
        const nextFreespins = GameState.getCurrentGame().latestRecord().freespinsTriggered;

        return triggered || nextFreespins ? Exit.True : Exit.False;
    }
}
